import _ from 'lodash';
import store from '$$globalStore';
import helpers from './helpers';

export default {
  fromStore(tasksToUpdate, ganttInstance) {
    const parentsToRefresh = [];
    let needClearAndParse = false;

    ganttInstance.batchUpdate(() => {
      tasksToUpdate.forEach(task => {
        if (!ganttInstance.isTaskExists(task.id)) {
          return;
        }

        const ganttTask = ganttInstance.getTask(task.id);
        const updatedTask = { ...ganttTask, ...task };

        if (ganttTask.sortorder !== updatedTask.sortorder && ganttInstance.config.gantt_id) {
          needClearAndParse = true;
        }

        if (ganttTask.parent !== updatedTask.parent) {
          ganttTask.parent && parentsToRefresh.push(ganttTask.parent);
          updatedTask.parent && parentsToRefresh.push(updatedTask.parent);
        }

        if (ganttTask.type !== updatedTask.type) {
          parentsToRefresh.push(task.id);
        }

        if (Object.prototype.hasOwnProperty.call(task, 'open')) {
          Object.assign(updatedTask, { $open: task.open });
        }

        if (ganttTask.parent === 1) { // for multiViews
          updatedTask.parent = 1;
        }

        const strToDate = ganttInstance.date.str_to_date(ganttInstance.config.date_format);

        if (_.isString(updatedTask.start_date)) {
          updatedTask.start_date = strToDate(updatedTask.start_date);
        }

        if (_.isString(updatedTask.end_date)) {
          updatedTask.end_date = strToDate(updatedTask.end_date);
        }

        if (updatedTask.deadline && _.isString(updatedTask.deadline)) {
          updatedTask.deadline = strToDate(updatedTask.deadline);
        }

        if (_.isString(updatedTask.estimation)) {
          updatedTask.estimation = parseFloat(updatedTask.estimation);
        }

        if (updatedTask.constraint_date) {
          updatedTask.constraint_date = null;
          updatedTask.constraint_type = null;
        }

        ganttInstance.silent(() => {
          ganttInstance.updateTask(task.id, updatedTask);
        });
      });
    });

    if (needClearAndParse) {
      helpers.clearAndParse(ganttInstance, true);
    } else if (parentsToRefresh.length) {
      helpers.updateButtonsInTasks(ganttInstance, parentsToRefresh);
    }

    if (ganttInstance.config.auto_scheduling) {
      ganttInstance.autoSchedule();
    }
  },

  fromGantt(tasksToUpdate, ganttInstance) {
    store.dispatch('tasksModel/updateTasks', {
      tasks: tasksToUpdate.map(item => item.data),
      // diff,
      // links: [],
      // fromGantt: true,
    });
  },
};
